export {default} from './AtlasSeats';
